import React from "react"
import Helmet from "react-helmet"

import Header from "./header"

const Layout = ({ children }) => {

  return (
  <>
    <Helmet>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" />
      <meta http-equiv="X-UA-Compatible" content="ie=edge" />
      <meta property='og:title' content="Linked in title description"/>
      <meta property="og:image" content="//f22labs.com/images/work/skymd.901736b4.png"/>
      <meta property='og:description' content="Description that will show in the preview"/>
      <meta property="og:url" content="//www.skymd.com/" />
      <meta name="title" content="F22 Labs - Clients testimonial" />
      <meta name="description" content="We specialize in Ruby on Rails, Angular.js, Node.js and mobile. We offer consulting, design, development and deployment services." />
      <meta name="keywords" content="f22labs, mobile development, web development, tabella web app" />
      <meta name="robots" content="index, follow" />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="author" content="F22 Labs" />
      <link rel="stylesheet" href="//cdn.materialdesignicons.com/5.0.45/css/materialdesignicons.min.css" />
    </Helmet>
    <div className="body-bg">
     <Header/>
     {children}
    </div>
  </>
  )
}

export default Layout
